export const ANIMATION_DURATION = 0.25;
export const childrenVariant = {
    start: { clipPath: "polygon(0 0, 0% 0, 0% 100%, 0% 100%)" },
    end: {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
        transition: {
            duration: ANIMATION_DURATION,
        },
    },
};
export const unattainedVariant = {
    start: childrenVariant.start,
    end: {
        clipPath: "polygon(-50% 0px, 100% -50%, 150% 150%, 0% 150%)",
        transition: {
            duration: ANIMATION_DURATION,
        },
    },
};
//# sourceMappingURL=levelsAnimation.js.map